export default {
  title: 'Dirección de entrega',
  buttons: {
    save: 'Guardar',
  },
};
